<template>
  <div>
    <div class="d-flex justify-end mb-3">
      <v-btn color="primary" @click="$router.push({ name: 'website.products.gemPages.create' })">
        <v-icon left>mdi-plus</v-icon> Create Gem Page
      </v-btn>
    </div>
    <v-card class="pa-0">
      <v-simple-table>
        <thead>
          <tr>
            <th>Title</th>
            <th>Handle</th>
            <th>Created</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in document" :key="item._id">
            <td>
              <div class="d-flex align-center w-100">
                <v-avatar tile size="40" height="auto" color="#dddd" class="text-center pointer mr-3">
                  <img :src="imageHelpers.url(item.image ? item.image : '/admin/img/no-image.png')" alt="" srcset="" />
                </v-avatar>
                <div
                  class="link-title"
                  @click="goEdit(item._id)"
                  style="color: #1976d2; cursor: pointer; min-width:300px;max-width:600px;word-break:break-word;"
                >
                  {{ item.title }}
                </div>
                <v-spacer />
              </div>
            </td>
            <td>{{ item.handle }}</td>
            <td>{{ formatDate(item.createdAt) }}</td>
            <td>
              <v-icon small style="cursor:pointer" @click="goView(item.handle)">mdi-eye</v-icon>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div class="d-flex justify-space-between px-3 pb-3">
        <limit-page :callback="setLimit" :page.sync="page" />
        <pagination :length="totalPages" :visible="0" :page.sync="page"></pagination>
      </div>
    </v-card>
  </div>
</template>

<script>
import { catalogService } from '@/apis/catalog';
import imageHelpers from '@/helpers/image';
import { mapGetters } from 'vuex';
export default {
  components: {},
  data() {
    return {
      document: [],
      countt: 0,
      page: 1,
      limit: 50,
      totalPages: 1,
      imageHelpers,
    };
  },
  created() {
    this.loadPages();
    this.loadCount();
  },
  computed: {
    ...mapGetters(['user', 'stores']),
  },
  methods: {
    async loadPages() {
      try {
        const params = { page: this.page, limit: this.limit };
        const res = await catalogService.getPages(params);
        this.document = res.data.catalogPages;
      } catch (error) {
        console.error(error);
      }
    },
    async loadCount() {
      try {
        const res = await catalogService.countPages();
        this.countt = res.data.count;
        this.totalPages = Math.ceil(this.countt / this.limit);
      } catch (error) {
        console.error(error);
      }
    },
    setLimit(newLimit) {
      this.limit = newLimit;
      this.loadPages();
    },
    goEdit(id) {
      this.$router.push({ name: 'website.products.gemPages.update', params: { id } });
    },
    goView(handle) {
      const storeId = localStorage.getItem('store-id');
      const store = this.stores.find(store => store.id === storeId);
      if (store) {
        const domain = store?.primaryDomain || store?.storeDetail?.defaultSystemDomain;
        window.open(`https://${domain}/posts/${handle}`);
      } else {
        window.open('https://' + this.$store.state.auth.accountInfo.rDomain + `/posts/${handle}`);
      }
    },
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleString();
    },
  },
  watch: {
    page() {
      this.loadPages();
    },
    limit() {
      this.loadPages();
    },
  },
};
</script>
